import { useMutation } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

interface Parameter {
  companyId: string
  body: {
    topic_id: string
    topic: string
    region: SEOCountries
  }
}

export async function createReport({ body, companyId }: Parameter) {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-research/reports/`
  try {
    const response = await axios.post(url, body)
    return extract.data<string>(response)
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useCreateReport() {
  return useMutation({
    mutationFn: createReport
  })
}
